import axios from "axios";
import config from "environment";

const { baseApi } = config;

export interface Thread {
  id: string;
  collectionId: string;
  sessionId: string;
  threadType: string;
  personaId: string | null;
  employeeId: string | null;
  createdAt: Date | string;
  messageCount: number;
  lastMessage: string | null;
  userEmail: string | null;
  userName: string | null;
  collection: {
    name: string;
    workspaceId: string;
  };
}

export interface ThreadMessage {
  id: number;
  type: string;
  userId: string | null;
  employeeId: string | null;
  content: string;
  sources: string[];
  personaIds: string[];
  classification: string | null;
  feedbackRating: number | null;
  timeToContent: number | null;
  timeToClassification: number | null;
  pinned: boolean;
  createdAt: Date | string;
  updatedAt: Date | string;
  user: {
    email: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
  employee: {
    email: string | null;
    firstName: string | null;
    lastName: string | null;
  } | null;
}

export interface ThreadDetails extends Thread {
  messages: ThreadMessage[];
}

export async function apiGetAllThreads(
  workspaceId: string,
  adminSecret: string
): Promise<Thread[]> {
  try {
    // Create a separate axios instance for admin requests
    const adminClient = axios.create({
      baseURL: baseApi,
      headers: {
        "Content-Type": "application/json",
        "Admin-Secret": adminSecret,
      },
    });

    const response = await adminClient.get(`/admin/threads/${workspaceId}`);
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching threads:", error);
    return [];
  }
}

export async function apiGetThreadDetails(
  threadId: string,
  adminSecret: string
): Promise<ThreadDetails | null> {
  try {
    const adminClient = axios.create({
      baseURL: baseApi,
      headers: {
        "Content-Type": "application/json",
        "Admin-Secret": adminSecret,
      },
    });

    const response = await adminClient.get(`/admin/threads/details/${threadId}`);
    return response.data?.data || null;
  } catch (error) {
    console.error("Error fetching thread details:", error);
    return null;
  }
}

export async function apiGetThreadsByUser(
  workspaceId: string,
  userId: string,
  adminSecret: string
): Promise<Thread[]> {
  try {
    const adminClient = axios.create({
      baseURL: baseApi,
      headers: {
        "Content-Type": "application/json",
        "Admin-Secret": adminSecret,
      },
    });

    const response = await adminClient.get(`/admin/threads/${workspaceId}/user/${userId}`);
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching threads by user:", error);
    return [];
  }
}